<template>
  <b-row class="d-flex justify-content-center align-items-center h-90-vh" style="border-width: 20px;">
    <b-col sm="8" md="6" lg="6">
      <div class="text-center mb-4">
        <img class="img-auth-sidebar" src="/assets/images/auth/auth-sidebar.png" alt="">
      </div>
    </b-col>
    <b-col sm="8" md="6" lg="6">
      <div class="mb-4">
        <img src="/assets/images/auth/tutwurihandayani.png" style="max-width: 260px !important;" alt="">
        <img height="50" class="d-block" src="/assets/images/auth/sibos.png" style="max-width: 260px !important;" alt="">
        <p class="ml-3">SISTEM INFORMASI BANTUAN OPERASIONAL SEKOLAH</p>
      </div>
      <b-card>
        <div class="flex-between-center">
          <h3 class="font-weight-bold">Masuk</h3>
          <p>Silahkan masuk ke akun anda</p>

          <ValidationObserver v-slot="{ handleSubmit }">
              <form @submit.prevent="handleSubmit(onSubmit)">

              <form-group-input placeholder="Nama pengguna anda" :need-label="false" v-model="model.username" rules="required" id="username" />
              <div class="mt-3 w-100"></div>
              <form-group-input placeholder="Password anda" :need-label="false" v-model="model.password" rules="required" type="password" id="password" />
              <!-- <b-row class="flex-between-center">
                <b-col cols="auto">
                  <a class="fs--1" href="#">Forgot Password?</a>
                </b-col>
              </b-row> -->
              <div class="col-6 mx-auto">
                <b-button type="submit" variant="primary" block class="w-100 mt-3 auth-btn"><font-awesome-icon icon="spinner" spin v-if="isLoading"></font-awesome-icon> Masuk</b-button>
              </div>
            </form>
          </ValidationObserver>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import FormGroupInput from '@/components/FormGroupInput.vue';
export default {
  components: {
    FormGroupInput
  },
  data () {
    return {
      isLoading: false,
      model: {
        username: null,
        password: null
      }
    }
  },
  methods: {
    onSubmit () {
      if (this.isLoading) {
        return false
      }
      this.isLoading = true
      this.$store.dispatch('account/login', {
        username: this.model.username,
        password: this.model.password
      }).then(() => {
        // this.$store.dispatch('notification/welcome', this.$store.getters['account/accountData'].firstName)
        this.isLoading = false
        this.$router.push(this.$route.query.redirect !== undefined && !this.$route.query.redirect.includes('logout') ? this.$route.query.redirect : '/').then(() => {
          // location.reload()
        })
      }).catch(error => {
        this.isLoading = false
        // console.log(serializeErrorMessage)
        this.$store.dispatch('notification/error', error)
        // this.$store.dispatch('notification/error', 'Kombinasi email & password anda salah')
      })
    }
  }
}
</script>